import type { FaireProductEntity } from "../../entity_types/product";

export const p_8g2mbmh5mg: FaireProductEntity = {
  token: "p_8g2mbmh5mg",
  type: "product",
  name: "Set of 2 White Large stoneware ceramic Pet Bowls — Party Collection",
  brandToken: "b_5ja2cf4hvd",
  brandName: "Egg Back Home USA",
  imageUrl:
    "https://cdn.faire.com/fastly/a2eca5f1c897f8b295954c9f622252a0a0400d95ac026ae8cd01650d423906a8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b836a37cd48b02cc2e16d9145993e5d97ea0d2f6d02000e23f76e311bfb818af.jpeg",
    "https://cdn.faire.com/fastly/c57e0c87d3e7c00a796ec4783c477a55e2b2aa6667906392bd4704cb2b5fd8eb.jpeg",
  ],
  priceDollars: 21.5,
  description:
    'Introducing our lovely "New Party Pet Bowl"! The option from the "New Party Collection" that was missing to your best friend, so your entire home could enjoy the vibrant and lively aesthetic of this collection, full of love :)\n\nThis set contains:\n\n2x New Party Pet Bowl 6,49in White\n\nDimensions:\n\nDiameter: 6,49 in\nHeight: 2,75 in\n\n\nAll our pieces are:\n\nDishwasher and microwave safe.\nFood safe.\nCadmium Free.\nMaterial: Stoneware with less than 3% absorption.\n\nOur Party Collection features a special type of glaze that may exhibit areas where speckles become diffused due to the glass\'s reactive nature during processing. We find these unique, unpredictable variations to be the most beautiful aspect of the glaze.\n\nCrafted with meticulous care, each Party Serving Bowl is a testament to our commitment to producing unique and exceptional tableware. Our artisanal process ensures that no two pieces are exactly alike, celebrating individuality. Please note that glaze colors may slightly vary due to production techniques. If you have any queries or seek more information, please don\'t hesitate to reach out to us.\n',
  tags: [],
  msrpDollars: 43,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:24.528Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
